import React from "react";


function ProductBasketOrder(props) {
    return (


                <div className="flex items-center space-x-4 p-4 bg-cream rounded-lg">
                    <div className="h-16 w-16 overflow-hidden rounded-lg flex-shrink-0">
                        <img className="w-full h-full object-cover"
                             src={props.image}
                             alt={props.name}/>
                    </div>
                    <div className="flex-grow">
                        <h4 className="font-semibold font-print text-gray-800">{props.name}</h4>
                        <p className="text-sm text-gray-600">Qty: {props.quantity}</p>
                    </div>
                    <span className="font-bold text-custom-green">€{props.price}</span>
                </div>


    );

}

export default ProductBasketOrder;